import { useEffect, useMemo } from 'react'
import { Platform, useWindowDimensions } from 'react-native'
import { getEffectiveAccountAdminWebDrawerShiftPx } from '../helpers/accountAdminNav.helper'
import { useAccountAdminDrawerShift } from '../contexts/AccountAdminDrawerShiftContext'

/**
 * On web, reports drawer width as horizontal inset so shell layouts can shift and stay clear of the overlay.
 *
 * @param manageShift When false, does not update shift. Use when another layer (e.g. root
 *   `AccountAdminNavDrawerHost`) owns sync — passing only `open: false` would otherwise reset that margin.
 */
export function useSyncAccountAdminDrawerWebPushPx(manageShift: boolean, open: boolean): void {
  const { width } = useWindowDimensions()
  const shiftPx = useMemo(
    () => getEffectiveAccountAdminWebDrawerShiftPx(open, width),
    [open, width],
  )
  const { setDrawerShiftPx } = useAccountAdminDrawerShift()

  useEffect(() => {
    if (Platform.OS !== 'web' || !manageShift) {
      return undefined
    }
    setDrawerShiftPx(shiftPx)
    return () => {
      setDrawerShiftPx(0)
    }
  }, [manageShift, shiftPx, setDrawerShiftPx])
}
